<template>
    <div class="news-list-page">
        <HeaderPc />
        <div class="page-container">
            <div class="container">
                <!-- 左侧主内容 -->
                <div class="main-content">
                    <div class="tab-bar">
                        <div
                            class="tab-item"
                            :class="{ active: activeTab === 1 }"
                            @click="switchTab(1)"
                        >市场动态</div>
                        <div
                            class="tab-item"
                            :class="{ active: activeTab === 2 }"
                            @click="switchTab(2)"
                        >通知公告</div>
                    </div>

                    <div class="list-wrap">
                        <div class="skeleton-list" v-if="loading">
                            <div class="skeleton-item" v-for="i in 8" :key="i">
                                <div class="sk-thumb"></div>
                                <div class="sk-body">
                                    <div class="sk-title"></div>
                                    <div class="sk-text"></div>
                                </div>
                            </div>
                        </div>

                        <div class="empty-state" v-else-if="list.length === 0">
                            <i class="el-icon-document"></i>
                            <p>暂无相关内容</p>
                        </div>

                        <template v-else>
                            <div
                                class="news-item"
                                v-for="item in list"
                                :key="item.id"
                                @click="goDetail(item.id)"
                            >
                                <img
                                    v-if="item.cover"
                                    :src="getImageUrl(item.cover)"
                                    class="news-thumb"
                                    @error="handleImgError"
                                />
                                <div class="news-body">
                                    <h3 class="news-title">{{ item.title }}</h3>
                                    <p class="news-summary">{{ item.summary }}</p>
                                    <div class="news-meta">
                                        <span><i class="el-icon-time"></i> {{ item.create_time }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="pagination-wrap">
                                <el-pagination
                                    background
                                    layout="prev, pager, next, total"
                                    :current-page="page"
                                    :page-size="pageSize"
                                    :total="total"
                                    @current-change="handlePageChange"
                                />
                            </div>
                        </template>
                    </div>
                </div>

                <!-- 右侧侧边栏 -->
                <div class="sidebar">
                    <div class="sidebar-block">
                        <div class="sidebar-title">
                            <i class="el-icon-s-flag"></i> 通知公告
                        </div>
                        <div
                            class="sidebar-item"
                            v-for="item in noticeList"
                            :key="item.id"
                            @click="goDetail(item.id)"
                        >
                            <span class="dot"></span>
                            <span class="sidebar-item-title">{{ item.title }}</span>
                        </div>
                        <div class="sidebar-empty" v-if="noticeList.length === 0">暂无公告</div>
                    </div>
                    <div class="sidebar-block">
                        <div class="sidebar-title">
                            <i class="el-icon-data-line"></i> 市场动态
                        </div>
                        <div
                            class="sidebar-item"
                            v-for="item in marketList"
                            :key="item.id"
                            @click="goDetail(item.id)"
                        >
                            <span class="dot"></span>
                            <span class="sidebar-item-title">{{ item.title }}</span>
                        </div>
                        <div class="sidebar-empty" v-if="marketList.length === 0">暂无动态</div>
                    </div>
                </div>
            </div>
        </div>
        <FooterPc />
    </div>
</template>

<script>
import HeaderPc from '@/components/pc/header.vue';
import FooterPc from '@/components/pc/fotter.vue';
import { getNewsList } from '@/api/news';

export default {
    name: 'NewsList',
    components: { HeaderPc, FooterPc },
    data() {
        return {
            activeTab: 1,
            list: [],
            loading: false,
            page: 1,
            pageSize: 10,
            total: 0,
            noticeList: [],
            marketList: []
        };
    },
    created() {
        const type = parseInt(this.$route.query.type) || 1;
        this.activeTab = type;
        this.fetchList();
        this.fetchSidebar();
    },
    methods: {
        switchTab(type) {
            if (this.activeTab === type) return;
            this.activeTab = type;
            this.page = 1;
            this.$router.replace({ query: { type } });
            this.fetchList();
        },
        fetchList() {
            this.loading = true;
            getNewsList({ type: this.activeTab, page: this.page, limit: this.pageSize })
                .then(res => {
                    if (res.code) {
                        this.list = res.data.list || [];
                        this.total = res.data.total || 0;
                    }
                })
                .finally(() => { this.loading = false; });
        },
        fetchSidebar() {
            getNewsList({ type: 2, page: 1, limit: 6 }).then(res => {
                if (res.code) this.noticeList = res.data.list || [];
            });
            getNewsList({ type: 1, page: 1, limit: 6 }).then(res => {
                if (res.code) this.marketList = res.data.list || [];
            });
        },
        handlePageChange(p) {
            this.page = p;
            this.fetchList();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        goDetail(id) {
            this.$router.push(`/news/${id}`);
        },
        getImageUrl(url) {
            if (!url) return require('@/static/imgs/default.jpeg');
            if (url.startsWith('http://') || url.startsWith('https://')) return url;
            return process.env.VUE_APP_STATIC_URL + url;
        },
        handleImgError(e) {
            e.target.src = require('@/static/imgs/default.jpeg');
        }
    }
};
</script>

<style scoped>
.news-list-page {
    min-height: 100vh;
    background: #f5f5f5;
}
.page-container {
    padding: 20px 0 40px;
}
.container {
    width: 80%;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    align-items: flex-start;
}

/* 主内容 */
.main-content {
    flex: 1;
    min-width: 0;
}
.tab-bar {
    display: flex;
    background: #fff;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    border-bottom: 2px solid #e1251b;
}
.tab-item {
    padding: 14px 32px;
    font-size: 15px;
    font-weight: 500;
    color: #666;
    cursor: pointer;
    transition: all 0.2s;
}
.tab-item:hover { color: #e1251b; }
.tab-item.active {
    color: #fff;
    background: #e1251b;
}

.list-wrap {
    background: #fff;
    border-radius: 0 0 8px 8px;
    padding: 16px 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* 新闻条目 */
.news-item {
    display: flex;
    gap: 16px;
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;
    cursor: pointer;
    transition: background 0.2s;
}
.news-item:last-of-type { border-bottom: none; }
.news-item:hover .news-title { color: #e1251b; }
.news-thumb {
    width: 140px;
    height: 90px;
    object-fit: cover;
    border-radius: 6px;
    flex-shrink: 0;
}
.news-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.news-title {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s;
}
.news-summary {
    font-size: 13px;
    color: #888;
    margin: 0 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.6;
}
.news-meta {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #aaa;
}
.news-meta i { margin-right: 4px; }

.pagination-wrap {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

/* 空状态 */
.empty-state {
    text-align: center;
    padding: 60px 0;
    color: #94a3b8;
}
.empty-state i { font-size: 48px; margin-bottom: 12px; color: #cbd5e1; }
.empty-state p { margin: 0; font-size: 14px; }

/* 骨架屏 */
.skeleton-list { display: flex; flex-direction: column; gap: 16px; padding: 8px 0; }
.skeleton-item { display: flex; gap: 16px; }
.sk-thumb {
    width: 140px; height: 90px; border-radius: 6px; flex-shrink: 0;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: sk 1.5s infinite;
}
.sk-body { flex: 1; display: flex; flex-direction: column; gap: 10px; padding-top: 4px; }
.sk-title {
    height: 18px; border-radius: 4px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: sk 1.5s infinite;
}
.sk-text {
    height: 14px; width: 70%; border-radius: 4px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: sk 1.5s infinite;
}
@keyframes sk {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* 侧边栏 */
.sidebar {
    width: 260px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.sidebar-block {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.sidebar-title {
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    background: #e1251b;
    display: flex;
    align-items: center;
    gap: 6px;
}
.sidebar-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-bottom: 1px solid #f5f5f5;
    cursor: pointer;
    transition: background 0.2s;
}
.sidebar-item:last-child { border-bottom: none; }
.sidebar-item:hover { background: #fff5f5; }
.sidebar-item:hover .sidebar-item-title { color: #e1251b; }
.dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #e1251b;
    flex-shrink: 0;
}
.sidebar-item-title {
    font-size: 13px;
    color: #444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s;
}
.sidebar-empty {
    padding: 16px;
    font-size: 13px;
    color: #aaa;
    text-align: center;
}
</style>
